import { render } from "./NewSphere.vue?vue&type=template&id=9e8433a4&scoped=true"
import script from "./NewSphere.vue?vue&type=script&lang=js"
export * from "./NewSphere.vue?vue&type=script&lang=js"

import "./NewSphere.vue?vue&type=style&index=0&id=9e8433a4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9e8433a4"]])

export default __exports__